import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
// import Vant from 'vant'
// import { Lazyload } from 'vant'
// import 'vant/lib/index.css'
import './assets/css/common.css'
import Api from './assets/js/api.js'
import Qiniu from './assets/js/qiniu.js'
import Report from './assets/js/report.js'
import App from './App.vue'
import VueClipboard from 'vue-clipboard2'


Vue.prototype.$api = Api
Vue.prototype.$qiniu = Qiniu
Vue.prototype.$report = Report
Vue.config.productionTip = false
// Vue.use(Vant)
// Vue.use(Lazyload)
Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueClipboard)


const Routers = [
  {
    path: '/',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/entry_enroll.vue'], resolve)
  },
  {
    path: '*',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./components/HelloWorld.vue'], resolve)
  },
  {
    path: '/loading',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/loading.vue'], resolve)
  },
  {
    path: '/entry_adult',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/entry_adult.vue'], resolve)
  },
  {
    path: '/entry_pay_without_fill',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/entry_pay_without_fill.vue'], resolve)
  },
  {
    path: '/entry_adult_via_coupon',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/entry_adult_via_coupon.vue'], resolve)
  },
  {
    path: '/entry_pay_without_fill_via_coupon',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/entry_pay_without_fill_via_coupon.vue'], resolve)
  },
  {
    path: '/entry_enroll',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/entry_enroll.vue'], resolve)
  },
  {
    path: '/entry_result',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/entry_result.vue'], resolve)
  },
  {
    path: '/choose_me_sex',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_me_sex.vue'], resolve)
  },
  {
    path: '/choose_me_age',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_me_age.vue'], resolve)
  },
  {
    path: '/choose_me_city',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_me_city.vue'], resolve)
  },
  {
    path: '/choose_me_jobs',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_me_jobs.vue'], resolve)
  },
  {
    path: '/choose_me_education',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_me_education.vue'], resolve)
  },
  {
    path: '/choose_me_intro',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_me_intro.vue'], resolve)
  },
  {
    path: '/choose_me_tags',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_me_tags.vue'], resolve)
  },
  {
    path: '/choose_me_contact',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_me_contact.vue'], resolve)
  },
  {
    path: '/choose_partner_sex',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_partner_sex.vue'], resolve)
  },
  {
    path: '/choose_partner_age',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_partner_age.vue'], resolve)
  },
  {
    path: '/choose_partner_city',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_partner_city.vue'], resolve)
  },
  {
    path: '/choose_partner_jobs',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_partner_jobs.vue'], resolve)
  },
  {
    path: '/choose_partner_surprise',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/choose_partner_surprise.vue'], resolve)
  },
  {
    path: '/entry_submit',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/entry_submit.vue'], resolve)
  },
  {
    path: '/entry_waiting',
    meta: {
      title: '',
      keepAlive: true
    },
    component: (resolve) => require(['./views/entry_waiting.vue'], resolve)
  },
  {
    path: '/rules_user_protocal',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/rules_user_protocal.vue'], resolve)
  },
  {
    path: '/rules_privacy',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/rules_privacy.vue'], resolve)
  },
  {
    path: '/match_result',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/match_result.vue'], resolve)
  },
  {
    path: '/entry_match_shortcut',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/entry_match_shortcut.vue'], resolve)
  },
  {
    path: '/unmatched_choose_partner_suprise',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/unmatched_choose_partner_suprise.vue'], resolve)
  },
  {
    path: '/bought',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/bought.vue'], resolve)
  },
  {
    path: '/not_found',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/not_found.vue'], resolve)
  },
  {
    path: '/captain_form_entry',
    meta: {
      title: '浪漫员·机长报名表'
    },
    component: (resolve) => require(['./views/captain_form_entry.vue'], resolve)
  },
  {
    path: '/captain_form_create',
    meta: {
      title: '浪漫员·机长报名表'
    },
    component: (resolve) => require(['./views/captain_form_create.vue'], resolve)
  },
  {
    path: '/arrange_date_entry',
    meta: {
      title: '浪漫员·1v1预约'
    },
    component: (resolve) => require(['./views/arrange_date_entry.vue'], resolve)
  },
  {
    path: '/arrange_date_pay',
    meta: {
      title: '浪漫员·1v1预约'
    },
    component: (resolve) => require(['./views/arrange_date_pay.vue'], resolve)
  },
  {
    path: '/groupon_propose_entry',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/groupon_propose_entry.vue'], resolve)
  },
  {
    path: '/groupon_choose_sex',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/groupon_choose_sex.vue'], resolve)
  },
  {
    path: '/groupon_pay_create',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/groupon_pay_create.vue'], resolve)
  },
  {
    path: '/groupon_invite_postcard/:groupon_uid',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/groupon_invite_postcard.vue'], resolve)
  },
  {
    path: '/groupon_invited_entry/:groupon_uid',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/groupon_invited_entry.vue'], resolve)
  },
  {
    path: '/groupon_invited_choose_sex',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/groupon_invited_choose_sex.vue'], resolve)
  },
  {
    path: '/groupon_invited_pay',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/groupon_invited_pay.vue'], resolve)
  },
  {
    path: '/enroll_qrcode_for_miniprogram/:referal',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/enroll_qrcode_for_miniprogram.vue'], resolve)
  },
  {
    path: '/distributor_entry',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/distributor_entry.vue'], resolve)
  },
  {
    path: '/distributor_center',
    meta: {
      title: ''
    },
    component: (resolve) => require(['./views/distributor_center.vue'], resolve)
  },
  {
    path: '/freelancer_apply_xhs_entry',
    meta: {
      title: '小红书兼职报名表'
    },
    component: (resolve) => require(['./views/freelancer_apply_xhs_entry.vue'], resolve)
  },
  {
    path: '/freelancer_apply_xhs_create',
    meta: {
      title: '小红书兼职报名表'
    },
    component: (resolve) => require(['./views/freelancer_apply_xhs_create.vue'], resolve)
  }
]

const RouterConfig = {
  mode: 'history',
  routes: Routers
}
const router = new VueRouter(RouterConfig)

const store = new Vuex.Store({
  state: {
    userinfo: {
      headimg: '',
      nickname: '',
      openid: '',
      subscribe: 0,
      paid: 0,
      fill: 0,
      level: 'basic',
      block: 0,
      groupon_uid: ''
    },
    favicon: 'https://static.huiyiji520.com/logo-wanxin-1645152729.jpg',
    staticUrl: 'https://static.huiyiji520.com',
    siteDomain: 'https://cp.langmanyuan.com',
    webAuthUrl: 'https://cp.langmanyuan.com',
    siteTitle: '',
    siteSlogan: '',
    siteCode: '',
    issue: 50,
    currentStage: 'enrolling', //活动当前阶段 报名中:enrolling;匹配中(可报名):matching;匹配中(停止报名):matched;查询中:lookuping;本期结束:finished
    timePayDeadline: '3月27日',
    timeLookup: '3月27日晚19点',
    timeGroup: '3月28日晚18点',
    timeRefund: '4月3日',
    referal: 'matrix',
    coupon: 'matrix',
    cpchoose: {
      mySex: '',
      myBirth: '',
      myProvince: '',
      myCity: '',
      myJob: '',
      myEducation: '/',
      myIntro: '',
      myTags: [],
      myPhone: '',
      myWechat: '',
      partnerSex: 'differ',
      partnerAge: '',
      partnerCity: '',
      partnerJob: '',
      partnerSurprise: '',
      fid: ''
    },
    submitted: 0,
    groupinfo: {
      capacity: 0,
      pay_type: "",
      groupon_uid: ""
    }
  },

  mutations: {
    setUserinfo(state, params){
      // alert('nickname: ' + params.nickname)
      state.userinfo = {headimg: params.headimg, nickname: params.nickname, openid: params.openid, subscribe: params.subscribe, paid: params.paid, fill: params.fill, level: params.level, block: params.block, groupon_uid: params.groupon_uid}
      // alert('user block: ' + params.block)
      if(params.block == 1){
        router.replace('/not_found')
      }else if((params.paid == 1) && (params.fill == 1) && (!params.destination.includes('match_result')) && (!params.destination.includes('captain_form_create')) && (!params.destination.includes('arrange_date_pay')) && (!params.destination.includes('distributor_center')) && (!params.destination.includes('freelancer_apply_xhs_create')) ){
        router.replace('/entry_waiting')
      }else if((params.paid == 1) && (params.fill == 0) && (params.groupon_uid != '') ){
        router.replace(`/groupon_invite_postcard/${params.groupon_uid}`)
      }else if(params.destination){
        router.replace(params.destination)
      }
    },
    setReferal(state, params){
      state.referal = params.referal
    },
    updatSubmitted(state, params){
      state.submitted = params.submitted
    },
    updateCpChoose(state, params){
      state.cpchoose = params
    },
    updateCpChooseFid(state, params){
      state.cpchoose.fid = params.fid
    },
    updatePayStatus(state, params){
      state.userinfo.paid = params.paid
    },
    updateCoupon(state, params){
      state.coupon = params.coupon
    },
    updateGroupCapacity(state, params){
      state.groupinfo.capacity = params.capacity
    },
    updateGroupPaytype(state, params){
      state.groupinfo.pay_type = params.pay_type
    },
    updateGroupUid(state, params){
      state.groupinfo.groupon_uid = params.groupon_uid
    }
  }
});

router.beforeEach((to, from, next) => {
  // alert('store state userinfo openid: ' + store.state.userinfo.openid)
  // alert('from path: ' + JSON.stringify(from.path))
  window.document.title = to.meta.title || store.state.siteTitle
  // console.log('to.path: ' + JSON.stringify(to.path))
  let paths = [
    "/loading", "/", "/entry_adult_via_coupon", "/entry_result", "/entry_match_shortcut", "/unmatched_choose_partner_suprise",
    "/captain_form_entry", "/arrange_date_entry", "/groupon_propose_entry", "/distributor_entry", "/freelancer_apply_xhs_entry"
  ]
  // if( (to.path === "/loading") || (to.path === "/") || (to.path === "/entry_adult_via_coupon") || (to.path === "/entry_result") || (to.path === "/entry_match_shortcut") || (to.path === "/unmatched_choose_partner_suprise") || (to.path === "/captain_form_entry") || (to.path === "/arrange_date_entry") ){
  if( paths.includes(to.path) ||  (to.path.indexOf("/groupon_invited_entry") >= 0) || (to.path.indexOf("/enroll_qrcode_for_miniprogram") >= 0) ){
    next()
  }else if( (from.path === "/entry_submit") && (store.state.submitted == 1) ){
    next(false)
    return ''
  }else if(store.state.userinfo.openid){
    next()
  }else{
    // next()
    window.location.replace("https://api.langmanyuan.com/api/couple/snsapi_userinfo?url=" + store.state.webAuthUrl + "/loading?destination=" + encodeURIComponent(to.fullPath))
  }
})

new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => {
    return h(App)
  }
})

window.onresize = setHtmlFontSize
function setHtmlFontSize () {
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
  const htmlDom = document.getElementsByTagName('html')[0]
  htmlDom.style.fontSize = htmlWidth / 10 + 'px'
}
setHtmlFontSize()
